import React from "react"
import { MainLayout } from "@/novus/layouts/MainLayout"

const LoadingScreen = () => {
  return <MainLayout />
}

export default LoadingScreen
